// removed by extract-text-webpack-plugin
module.exports = {"form":"src-components-SearchInput----SearchInput-module---form---_tLmv","search":"src-components-SearchInput----SearchInput-module---search---_A-bi","button":"src-components-SearchInput----SearchInput-module---button---3T4C_","input":"src-components-SearchInput----SearchInput-module---input---lNdnj","icon":"src-components-SearchInput----SearchInput-module---icon---2cs-T"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SearchInput/SearchInput.module.scss
// module id = 201
// module chunks = 82273022296103 114276838955818 193433272603103